'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _constants = require('../../constants');

var _components = require('../../components');





var _formatPhoneNumber = require('../../utils/formatPhoneNumber');

var _LeadItem = require('./LeadItem.scss');var styles = _interopRequireWildcard(_LeadItem);
var _verified = require('../../../static/icons/verified.svg');var _verified2 = _interopRequireDefault(_verified);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Constants
// Components
// helpers
// styles
var LeadItem = function (_Component) {_inherits(LeadItem, _Component);function LeadItem(props) {_classCallCheck(this, LeadItem);var _this = _possibleConstructorReturn(this, _Component.call(this, props));_this.







    toggleState = function () {
      _this.setState({ isOpen: !_this.state.isOpen });
    };_this.

    openLead = function () {
      _this.handleModalClose();
      _this.props.sendViewLeadPhone({
        id: _this.props.id,
        token: _this.props.userToken });

      _this.props.changeNumberLeads();
      _this.setState({ isShownEmail: true, isShownPhone: true });
      _this.props.setDensityUnreadLeads(_this.props.numberUnreadLeads - 1);
    };_this.

    handleShowPhone = function () {
      if (_this.props.isViewed) {
        _this.setState({ isShownPhone: true });
        return;
      }

      if (!_this.props.canOpenLead && !_this.props.userLeads.unlimited) {
        _this.props.handleOpenBuyModal();
        return;
      }
      _this.showConfirmation();
    };_this.


    handleShowEmail = function () {
      if (_this.props.isViewed) {
        _this.setState({ isShownEmail: true });
        return;
      }

      if (!_this.props.canOpenLead && !_this.props.userLeads.unlimited) {
        _this.props.handleOpenBuyModal();
        return;
      }
      _this.showConfirmation();
    };_this.

    handleModalClose = function () {
      _this.props.hideMessageModal();
    };_this.

    showConfirmation = function () {
      _this.props.openMessageModal({
        message:
        _react2.default.createElement('div', { className: 'contentMessage' },
          _react2.default.createElement('div', { className: styles.confirmationPopup },
            _react2.default.createElement('p', null, _this.props.translate('buyMoreQuestions', 'areYouSure')),
            _react2.default.createElement('button', {
                className: 'btn btn-primary',
                onClick: _this.openLead },

              _this.props.translate('buyMoreQuestions', 'yes')),

            _react2.default.createElement('button', {
                className: 'btn btn-default',
                onClick: _this.handleModalClose },

              _this.props.translate('buyMoreQuestions', 'no')))) });





    };_this.

    renderMessenger = function (item, idx) {return item &&
      _react2.default.createElement('span', { key: item },
        idx > 0 && ', ',
        _this.props.translate('propertyDetailsContactsUsForm', item));};_this.state = { isOpen: false, isShownPhone: false, isShownEmail: false };return _this;}LeadItem.prototype.



  render = function render() {var _cx,_cx2,_cx3,_cx4,_this2 = this;var _props =

    this.props,name = _props.name,numberInOrder = _props.numberInOrder,messengers = _props.messengers,sentDate = _props.sentDate,phone = _props.phone,aims = _props.aims,email = _props.email,message = _props.message,isViewed = _props.isViewed,entity_type = _props.entity_type,viewedAt = _props.viewedAt;
    var isShowDetailsBlock = aims.length || email || message;
    var dateInstance = (0, _moment2.default)(sentDate);
    var date = dateInstance.format('DD/MM/YYYY');
    var time = dateInstance.format('HH:mm');

    var viewedSateInstance = (0, _moment2.default)(viewedAt);
    var viewedDate = viewedSateInstance.format('DD/MM/YYYY');
    var viewedTime = viewedSateInstance.format('HH:mm');

    var ltrSymbol = String.fromCharCode(8206);
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(
          styles.leadWrapper, (_cx = {}, _cx[
          styles.opened] = this.state.isOpen, _cx), (_cx2 = {}, _cx2[
          styles.viewed] = isViewed, _cx2)) },


        _react2.default.createElement('div', { className: styles.container },
          _react2.default.createElement('div', { className: styles.row },
            _react2.default.createElement('div', { className: styles.orderColumn },
              numberInOrder + 1 + '.'),

            _react2.default.createElement('div', { className: styles.userColumn },
              _react2.default.createElement('div', { className: styles.iconUser },
                _react2.default.createElement('span', { className: (0, _classnames2.default)('icon', 'icon-user2') })),

              _react2.default.createElement('div', { className: styles.userInfo },
                _react2.default.createElement('div', { className: styles.name }, name),
                _react2.default.createElement('div', { className: styles.date },
                  _react2.default.createElement('span', null, this.props.translate('Leads', 'sent'), ' '),
                  _react2.default.createElement('span', null, date)),

                _react2.default.createElement('div', { className: styles.date },
                  _react2.default.createElement('span', null, time)))),



            entity_type === _constants.ENTITY_TYPES.PROPERTY &&
            _react2.default.createElement('div', { className: styles.propertyColumn },
              this.props.property.id &&
              _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelType, [this.props.property.search_option]) },
                this.props.translate('search_box', 'searchContainer', this.props.property.search_option)),


              _react2.default.createElement(_components.OMLeadPropertyCell, {
                property: this.props.property,
                translate: this.props.translate,
                locale: this.props.locale,
                isRtl: this.props.isRtl,
                isMobile: this.props.isMobile,
                openDetailsPopup: this.props.openDetailsPopup,
                entityType: entity_type })),



            entity_type === _constants.ENTITY_TYPES.PROJECT &&
            _react2.default.createElement('div', { className: styles.propertyColumn },
              this.props.property.id &&
              _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelType, [entity_type]) },
                this.props.translate('header', 'projects')),


              _react2.default.createElement(_components.OMLeadProjectCell, {
                property: this.props.property,
                translate: this.props.translate,
                locale: this.props.locale,
                isRtl: this.props.isRtl,
                isMobile: this.props.isMobile,
                openDetailsPopup: this.props.openDetailsPopup,
                entityType: entity_type })),



            _react2.default.createElement('div', { className: styles.contactsColumn },
              _react2.default.createElement('div', { className: styles.contactsRow },
                _react2.default.createElement('span', { className: styles.label }, this.props.translate('editProfile', 'phoneNumber'), ': '),
                this.state.isShownPhone ?
                _react2.default.createElement('a', { className: styles.text, href: 'tel:' + phone }, ltrSymbol, phone) :

                _react2.default.createElement('span', { className: styles.text },
                  ltrSymbol,
                  (0, _formatPhoneNumber.encodePhoneNumber)(phone)),



                !this.state.isShownPhone &&

                _react2.default.createElement('span', { className: styles.hideText, onClick: this.handleShowPhone },
                  this.props.translate('Leads', 'showNumber')),



                isViewed &&
                _react2.default.createElement(_components.TopTooltip, {
                  icon: _react2.default.createElement('img', { src: _verified2.default, alt: '' }),
                  className: styles.verifiedIconTooltip,
                  msg: _react2.default.createElement('span', null, this.props.translate('Leads', 'tooltipMessage')) })),




              _react2.default.createElement('div', { className: styles.contactsRow },
                messengers.length > 0 &&
                _react2.default.createElement('p', null, this.props.translate('Leads', 'socialTitle'),
                  messengers.map(this.renderMessenger))),



              _react2.default.createElement('div', null,
                viewedAt ?
                _react2.default.createElement('div', null,
                  _react2.default.createElement('div', { className: styles.date },
                    _react2.default.createElement('span', null, this.props.translate('Leads', 'viewed'), ' '),
                    _react2.default.createElement('span', null, viewedDate)),

                  _react2.default.createElement('div', { className: styles.date },
                    _react2.default.createElement('span', null, viewedTime))) :


                '')),


            _react2.default.createElement('div', { className: styles.actionColumn },
              _react2.default.createElement('button', {
                  // disabled={!this.props.isViewed}
                  type: 'button',
                  onClick: this.toggleState,
                  className: (0, _classnames2.default)(
                  styles.detailsButton, (_cx3 = {}, _cx3[
                  styles.showButton] = !this.state.isOpen, _cx3), (_cx4 = {}, _cx4[
                  styles.hideButton] = this.state.isOpen, _cx4)) },


                this.state.isOpen ?
                _react2.default.createElement('span', null, this.props.translate('Leads', 'hideDetails')) :

                _react2.default.createElement('span', null, this.props.translate('Leads', 'showDetails')),

                _react2.default.createElement('span', { className: styles.actionIcon }, '+')))),



          isShowDetailsBlock && this.state.isOpen &&
          _react2.default.createElement('div', { className: styles.details },
            aims.length > 0 &&
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.column, styles.rowColumn) },
              _react2.default.createElement('div', { className: styles.label },
                this.props.translate('Leads', 'interestedIn')),

              _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.value, styles.valueColumn) },
                aims.map(function (item) {return (
                    _react2.default.createElement('div', { key: item, className: styles.point },
                      _this2.props.translate('propertyDetailsContactsUsForm', item)));}))),





            message &&
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.column, styles.rowColumn) },
              _react2.default.createElement('div', { className: styles.label },
                this.props.translate('Leads', 'message'), ':'),

              _react2.default.createElement('div', { className: styles.value },
                this.state.isShownEmail ?
                _react2.default.createElement('span', { className: styles.text }, message) :
                _react2.default.createElement('span', { className: styles.text }, 'XXXXXXXXXXX'),

                !this.state.isShownEmail &&
                _react2.default.createElement('span', { className: styles.hideText, onClick: this.handleShowEmail },
                  this.props.translate('Leads', 'showMessage')))),





            email &&
            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.column, styles.rowColumn) },
              _react2.default.createElement('div', { className: styles.label },
                this.props.translate('propertyDetailsContactsUsForm', 'Email:')),

              _react2.default.createElement('div', { className: styles.value },
                this.state.isShownEmail ?
                _react2.default.createElement('span', { className: styles.text }, email) :
                _react2.default.createElement('span', { className: styles.text }, 'XXXXXXXXXXX'),

                !this.state.isShownEmail &&
                _react2.default.createElement('span', { className: styles.hideText, onClick: this.handleShowEmail },
                  this.props.translate('Leads', 'showEmail'))))))));










  };return LeadItem;}(_react.Component);


LeadItem.propTypes = {
  locale: _propTypes2.default.string,
  name: _propTypes2.default.string,
  id: _propTypes2.default.string,
  property: _propTypes2.default.object,
  phone: _propTypes2.default.string,
  email: _propTypes2.default.string,
  message: _propTypes2.default.string,
  messengers: _propTypes2.default.array,
  aims: _propTypes2.default.array,
  isRtl: _propTypes2.default.bool,
  numberInOrder: _propTypes2.default.number.isRequired,
  translate: _propTypes2.default.func,
  sentDate: _propTypes2.default.string,
  viewedAt: _propTypes2.default.string,
  changeNumberLeads: _propTypes2.default.func,
  isViewed: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  openDetailsPopup: _propTypes2.default.func,
  sendViewLeadPhone: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  entity_type: _propTypes2.default.string,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  canOpenLead: _propTypes2.default.bool,
  handleOpenBuyModal: _propTypes2.default.func,
  numberUnreadLeads: _propTypes2.default.number,
  setDensityUnreadLeads: _propTypes2.default.func,
  userLeads: _propTypes2.default.object };exports.default =


LeadItem;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LeadItem/LeadItem.js
// module id = 2708
// module chunks = 0